module.exports = __webpack_public_path__ + "static/media/credentials.9035e550.svg";